import { useEffect, useState } from 'react'
import api from '../services/api'

// Texto da Ocorrência (TOCOTEX, frota.ocodes) — o servidor quebra em linhas de 60 caracteres, igual ao ERP

const LARGURA = 60

export interface ChaveOcorrencia { ococod: string; ocodat: string; ocotip: number; oconro: number }

export default function OcorrenciaTextoModal({ chave, funcionario, tipo, onClose }: {
  chave: ChaveOcorrencia; funcionario: string; tipo: string; onClose: () => void
}) {
  const [texto, setTexto] = useState<string | null>(null)
  const [original, setOriginal] = useState('')
  const [erro, setErro] = useState('')
  const [aviso, setAviso] = useState('')
  const [salvando, setSalvando] = useState(false)

  useEffect(() => {
    api.get('/ocorrencias-funcionarios/texto', { params: chave })
      .then(r => { const t = (r.data as string[]).join('\n'); setTexto(t); setOriginal(t) })
      .catch(() => setErro('Não foi possível carregar o texto da ocorrência.'))
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  async function salvar() {
    setErro(''); setAviso('')
    setSalvando(true)
    try {
      const r = await api.put('/ocorrencias-funcionarios/texto', { ...chave, texto })
      const t = (r.data.linhas as string[]).join('\n')
      setTexto(t); setOriginal(t)
      setAviso(r.data?.semAlteracao ? 'Nenhuma alteração para salvar.' : `Texto salvo (${r.data.linhas.length} linha(s)).`)
    } catch (e: any) {
      setErro(e?.response?.data?.error || 'Erro ao salvar o texto.')
    } finally {
      setSalvando(false)
    }
  }

  function fechar() {
    if (texto !== null && texto !== original && !window.confirm('O texto foi alterado e não foi salvo. Fechar mesmo assim?')) return
    onClose()
  }

  const info = (rot: string, val: string | number) => (
    <div style={{ minWidth: 0 }}>
      <div style={{ fontSize: '0.68rem', fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.04em' }}>{rot}</div>
      <div style={{ fontSize: '0.88rem', fontWeight: 600, color: '#1b3f7b', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={String(val)}>{val}</div>
    </div>
  )
  const longas = texto ? texto.split('\n').filter(l => l.length > LARGURA).length : 0

  return (
    <div className="modal-overlay" style={{ zIndex: 1300 }} onClick={e => e.target === e.currentTarget && fechar()}>
      <div className="modal-box" style={{ maxWidth: 760, maxHeight: '92vh', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
        <div className="modal-header" style={{ background: 'linear-gradient(135deg, #1a6ea8, #14547f)', gap: '1rem' }}>
          <div style={{ minWidth: 0 }}><h2>Texto da Ocorrência</h2></div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', flexShrink: 0, marginLeft: 'auto' }}>
            <span style={{ fontSize: '0.78rem', fontWeight: 700, color: 'rgba(219,234,254,0.8)' }}>TOCOTEX</span>
            <button className="modal-fechar" onClick={fechar}>✕</button>
          </div>
        </div>

        <div className="modal-corpo" style={{ background: '#f1f5fb' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '110px minmax(0, 1fr) minmax(0, 1fr) 90px', gap: '0.75rem', padding: '0.75rem 1rem',
            background: '#fff', border: '1px solid #c7d6ea', borderRadius: 10, marginBottom: '0.9rem' }}>
            {info('Data', chave.ocodat.split('-').reverse().join('/'))}
            {info('Funcionário', funcionario || '—')}
            {info('Tipo', tipo)}
            {info('Número', chave.oconro)}
          </div>

          {texto === null ? (
            <p style={{ color: erro ? '#dc2626' : '#6b7280' }}>{erro || 'Carregando...'}</p>
          ) : (
            <>
              <textarea value={texto} rows={14} spellCheck={false} autoFocus
                style={{ width: '100%', boxSizing: 'border-box', fontFamily: 'Consolas, monospace', fontSize: '0.88rem', lineHeight: 1.5, resize: 'vertical',
                  padding: '0.6rem 0.8rem', border: '1.5px solid #c7d6ea', borderRadius: 8, background: '#fff' }}
                onChange={e => setTexto(e.target.value)} />
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.72rem', color: '#6b7280', marginTop: 4 }}>
                <span>{longas ? `${longas} linha(s) com mais de ${LARGURA} caracteres serão quebradas ao salvar.` : `Até ${LARGURA} caracteres por linha.`}</span>
                <span>{texto ? texto.split('\n').length : 0} linha(s)</span>
              </div>
            </>
          )}

          {texto !== null && erro && <p style={{ color: '#dc2626', fontSize: '0.82rem', margin: '0.8rem 0 0' }}>{erro}</p>}
          {aviso && <p style={{ color: '#16a34a', fontSize: '0.82rem', margin: '0.8rem 0 0' }}>{aviso}</p>}
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={fechar}>Fechar</button>
          <button className="btn btn-primary" onClick={salvar} disabled={salvando || texto === null}>{salvando ? 'Salvando...' : 'Salvar'}</button>
        </div>
      </div>
    </div>
  )
}
